import type { $Fetch } from 'ofetch';
import type { Questao, QuestaoTipo, QuestaoDificuldade, UpsertQuestaoCommand } from '@/domain/model/Questao';
import type { Page } from '@/domain/model/Page';
import type { QuestaoGateway } from '@/application/port/out/QuestaoGateway';
import type { ApiResponse, SpringPage } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

const PATH = '/api/v1/questoes';

export class HttpQuestaoGateway implements QuestaoGateway {
  constructor(private readonly client: $Fetch) {}

  async list(p: { tipo?: QuestaoTipo; dificuldade?: QuestaoDificuldade; page?: number; size?: number }): Promise<Page<Questao>> {
    const params: Record<string, string | number> = {};
    if (p.tipo) params['tipo'] = p.tipo;
    if (p.dificuldade) params['dificuldade'] = p.dificuldade;
    if (typeof p.page === 'number') params['page'] = p.page;
    if (typeof p.size === 'number') params['size'] = p.size;
    const res = await this.client<ApiResponse<SpringPage<Questao>>>(PATH, { method: 'GET', params });
    assertApiSuccess(res);
    const d = res.data;
    return { content: d.content, number: d.number, size: d.size, totalElements: d.totalElements, totalPages: d.totalPages, first: d.first, last: d.last };
  }

  async get(id: string): Promise<Questao> {
    const res = await this.client<ApiResponse<Questao>>(`${PATH}/${encodeURIComponent(id)}`, { method: 'GET' });
    assertApiSuccess(res);
    return res.data;
  }

  async create(command: UpsertQuestaoCommand): Promise<Questao> {
    const res = await this.client<ApiResponse<Questao>>(PATH, { method: 'POST', body: command });
    assertApiSuccess(res);
    return res.data;
  }

  async update(id: string, command: UpsertQuestaoCommand): Promise<Questao> {
    const res = await this.client<ApiResponse<Questao>>(
      `${PATH}/${encodeURIComponent(id)}`, { method: 'PUT', body: command },
    );
    assertApiSuccess(res);
    return res.data;
  }

  async delete(id: string): Promise<void> {
    // BE retorna 204 No Content (sem envelope) — não chamar assertApiSuccess
    await this.client<void>(
      `${PATH}/${encodeURIComponent(id)}`, { method: 'DELETE' },
    );
  }
}
